exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@keyframes example{0%{height:0;opacity:0}to{height:950px;opacity:1}}.lead-form{padding:15px;border:1px solid #e2e2e2;margin:10px;background:#f4f4f4;animation-name:example;animation-duration:.5s;max-height:1050px;margin-bottom:10px}.form-one-line .ms-TextField .ms-Label{display:inline-block;width:130px}.form-one-line .ms-TextField .ms-TextField-field{display:inline-block;width:calc(100% - 130px)}.form-one-line .ms-TextField .ms-Icon{top:6px}.form-one-line .ms-Dropdown-container{display:flex}.form-one-line .ms-Dropdown-container .ms-Label{display:inline-block;width:130px}.form-one-line .ms-Dropdown-container .ms-Dropdown{display:inline-block;width:calc(100% - 130px)}.form-one-line .ms-DatePicker{margin-bottom:10px}.relative-info{width:800px;max-width:800px}.certification-doc,.insurance-doc{max-width:1000px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./client/components/common/LeadForm/style.css
// module id = 1239
// module chunks = 0